import type { VFXEffectConfig, VFXPrimitive } from '../../VFXEffectRegistry';

/** Target marks retain their accepted status lifetime. The essential opposing
 * pair allocates first; accents may drop under the shared graphics budget. */
function plates(points: number[], color: number): VFXPrimitive[] {
  return [-1, 1].map(side => ({ type: 'polygon',
    polygonPoints: points.map((value, index) => index % 2 ? value : value * side),
    color, alpha: 0.85, depth: 101 }));
}
function strokes(points: Array<{ x: number; y: number }>, color: number, width: number): VFXPrimitive[] {
  return [-1, 1].map(side => ({ type: 'line',
    linePoints: points.map(point => ({ x: point.x * side, y: point.y })),
    color, lineWidth: width, alpha: 0.95, depth: 102 }));
}

export const WARLOCK_AFFLICTION_VFX: VFXEffectConfig[] = [
  { id: 'corruption_state', name: 'Gloammark', category: 'status', followTarget: 'player', minimumShapes: 2,
    description: 'Broken olive sigil brackets cling to the marked target, joined by pale stitches',
    primitives: [
      ...plates([23, -20, 31, -24, 36, -15, 31, -6, 35, 4, 31, 21, 24, 16, 27, 2, 23, -8, 28, -15], 0x8a9a2a),
      ...strokes([{ x: 30, y: -17 }, { x: 27, y: -10 }, { x: 32, y: -6 },
        { x: 28, y: 2 }, { x: 32, y: 8 }, { x: 28, y: 15 }], 0xd2e070, 1.8),
    ] },
  { id: 'immolate_state', name: 'Cinder Scar', category: 'status', followTarget: 'player', minimumShapes: 2,
    description: 'Two ember fractures hold narrow golden seams along the target edges',
    primitives: [
      ...plates([27, -23, 34, -12, 29, -3, 33, 5, 26, 23, 24, 9, 28, 1, 24, -8], 0xff6a00),
      ...strokes([{ x: 28, y: -16 }, { x: 30, y: -11 }, { x: 26, y: -3 },
        { x: 30, y: 5 }, { x: 27, y: 15 }], 0xffc04d, 1.8),
    ] },
  { id: 'agony_state', name: 'Last Toll', category: 'status', followTarget: 'player', minimumShapes: 2,
    description: 'A split magenta bell brand holds beside the target with a pale clapper below',
    primitives: [
      ...strokes([{ x: 22, y: -20 }, { x: 29, y: -16 }, { x: 33, y: -6 },
        { x: 33, y: 13 }, { x: 39, y: 22 }, { x: 22, y: 22 }], 0xd4247a, 3),
      ...strokes([{ x: 25, y: -15 }, { x: 29, y: -8 }, { x: 29, y: 14 }, { x: 34, y: 19 }], 0xff9ccc, 1.3),
      { type: 'polygon', polygonPoints: [0, 23, 5, 28, 0, 33, -5, 28], color: 0xff9ccc, alpha: 0.9, depth: 102 },
    ] },
];
